import { ReactElement } from "react";
import {
  CQMetriques,
  CQMetriquesResult,
} from "@src/data/controle-quinquennal/hook/useCQMetriquesQuery";
import style from "./CelluleMetrique.module.scss";

type CelluleMetriqueProps = {
  metriques: CQMetriquesResult;
  id: string;
  render: (metriques: CQMetriques) => ReactElement | null;
};

/**
 * Les métriques arrivent après la liste, par paquets : la cellule montre trois
 * points tant que le sien n'est pas revenu, puis la valeur — ou un tiret si le
 * contrôle n'en a pas.
 */
export function CelluleMetrique({
  metriques,
  id,
  render,
}: CelluleMetriqueProps) {
  const valeurs = metriques.parControle.get(id);

  if (!valeurs)
    return metriques.isPending(id) ? (
      <p className={style.chargement} aria-label="Calcul en cours">
        <span />
        <span />
        <span />
      </p>
    ) : (
      <p className={style.vide}>-</p>
    );

  return render(valeurs) ?? <p className={style.vide}>-</p>;
}
